var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 16,
  viewBox: "0 0 20 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_3582",
  "data-name": "Group 3582",
  transform: "translate(-349 -179)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3570",
  "data-name": "Group 3570",
  transform: "translate(347.5 174.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_127",
  "data-name": "Path 127",
  d: "M13.409,4.5a8.063,8.063,0,0,0-8,7.371V12.5a6.083,6.083,0,0,0,5.545,6.022,7.092,7.092,0,0,1-1.364.18,6.37,6.37,0,0,1-6.273-6.2.854.854,0,0,0-.909-.9.854.854,0,0,0-.909.9,8.064,8.064,0,0,0,8.091,8,7.936,7.936,0,0,0,8-7.371V12.5a6.083,6.083,0,0,0-5.545-6.022,7.093,7.093,0,0,1,1.364-.18,6.25,6.25,0,0,1,6.273,6.2.909.909,0,0,0,1.818,0A8.064,8.064,0,0,0,13.409,4.5Zm2.364,8a4.273,4.273,0,0,1-8.545,0,4.273,4.273,0,1,1,8.545,0Z",
  fill: "#9d24d6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_128",
  "data-name": "Path 128",
  d: "M18,19.95a2.1,2.1,0,1,0-2.1-2.1A2.1,2.1,0,0,0,18,19.95Z",
  transform: "translate(-6.5 -5.35)",
  fill: "#9d24d6"
})), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_34",
  "data-name": "Ellipse 34",
  cx: 5.5,
  cy: 5.5,
  r: 5.5,
  transform: "translate(354 182)",
  fill: "#9d24d6"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_33",
  "data-name": "Ellipse 33",
  cx: 2,
  cy: 2,
  r: 2,
  transform: "translate(357 185)",
  fill: "#fff"
}))));
export default __webpack_public_path__ + "static/media/innerCircle.4ef3d7bb.svg";
export { SvgComponent as ReactComponent };